<template>
    <table class="container-calendar-heat">
        <thead>
        <tr>
            <th></th>
            <th>JAN</th>
            <th>FEV</th>
            <th>MAR</th>
            <th>ABR</th>
            <th>MAI</th>
            <th>JUN</th>
            <th>JUL</th>
            <th>AGO</th>
            <th>SET</th>
            <th>OUT</th>
            <th>NOV</th>
            <th>DEZ</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(d,idx1) in valuesToShow" :key="idx1">
            <td v-for="(m,idx2) in d"
                :key="idx2"
                :title="m.title"
                :style="{backgroundColor: m.backgroundColor}">{{m.label}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "CalendarHeat",
        props: {
            values: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                calendar: []
            }
        },
        methods: {
            build() {
                ['', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', ''].forEach(nm => this.calendar.push([{label: nm, alt: '', backgroundColor: '#fff'}]));

                this.calendar.forEach(d => {
                    for (let i = 0; i < 12; i++)
                        d.push({backgroundColor: '#fff'});
                });
            },
            resetColor() {
                for (let j = 0; j < this.calendar.length; j++) {
                    for (let i = 1; i < this.calendar[j].length; i++) {
                        this.calendar[j][i].backgroundColor = '#fff';
                    }
                }
            }
        },
        computed: {
            valuesToShow() {
                this.resetColor();

                for (let i = 0; i < this.values.length; i++) {
                    const value = this.values[i];
                    let calc = value.value * 1 / this.max;
                    calc = calc < 0 ? calc * -1 : calc;
                    const number = calc * (1.0 - -1.0) + -1.0;
                    const cell = this.calendar[value.week_day][value.month + 1];
                    cell.backgroundColor = this.$appUtils.pSBC(number * -1, '#1AB39A');
                    cell.title = value.title;
                }
                return this.calendar
            },
            max() {
                let max = 0;

                if (this.values.length > 0) {
                    for (let i = 0; i < this.values.length; i++) {
                        const value = this.values[i].value;
                        if (value >= max) max = value;
                    }
                }

                return max
            }
        },
        mounted() {
            this.build();
        }
    }
</script>

<style scoped lang="scss">
    .container-calendar-heat {
        width: 100%;
        thead > tr > th {
            text-align: center;
            font-size: .7em;
        }
        tbody > tr > td {
            transition: all .2s ease;

            &:first-child {
                text-align: right;
                font-size: .7em;
                font-weight: bold;
            }

            &:not(:first-child):hover {
                cursor: pointer;
                transform: scale(1.2);
            }
        }

        th, td{
            border: 1px solid #fff;
            padding: 0.1rem;
        }
    }

    @media only screen and (max-width: 500px) {
        .container-calendar-heat {
            thead > tr > th {
                font-size: .5em;
            }
            tbody > tr > td {
                &:first-child {
                    font-size: .5em;
                }
            }
        }
    }
</style>
